import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, Clock, Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { fmtDate } from "@/lib/billing";

/* Calm status banner under the header — complimentary countdown, past-due, read-only, cancelling. */
export default function BillingBanner() {
  const { user } = useAuth();
  const loc = useLocation();
  const b = user?.billing;
  if (!b || !b.enabled || user?.role === "admin") return null;
  if (loc.pathname.startsWith("/billing")) return null;
  let tone = "", Icon = Clock, text = "";
  if (b.status === "complimentary") {
    tone = "border-sky-200 bg-sky-50 text-sky-900";
    text = `Complimentary access — ${b.days_left ?? 0} day${b.days_left === 1 ? "" : "s"} left (until ${fmtDate(b.complimentary_until)}). Subscribe any time to keep your credits flowing.`;
  } else if (b.status === "past_due") {
    tone = "border-amber-200 bg-amber-50 text-amber-900"; Icon = AlertTriangle;
    text = `Your renewal payment didn't go through. We'll retry automatically; the account turns read-only in ${b.days_left ?? 0} day(s).`;
  } else if (b.status === "read_only") {
    tone = "border-slate-300 bg-slate-100 text-slate-800"; Icon = Lock;
    text = "Read-only mode — you can view and export your list, but imports, scans and edits are paused until the overdue payment clears.";
  } else if (b.status === "cancelling") {
    tone = "border-slate-200 bg-slate-50 text-slate-700";
    text = `Your subscription ends on ${fmtDate(b.period_end)}. You can resume auto-renewal from Billing & Credits.`;
  } else {
    return null;
  }
  return (
    <div className={"rounded-lg border px-4 py-2.5 text-sm flex flex-wrap items-center gap-2 " + tone} data-testid={`billing-banner-${b.status}`}>
      <Icon className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-[200px]">{text}</span>
      <Link to="/billing" className="text-sm font-semibold underline" data-testid="billing-banner-link">Billing & Credits</Link>
    </div>
  );
}
